import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { sm, xs, md } = constants.breakpoints.BreakpointNames;
const { ui } = constants.colors;

const greyDark = ui.neutral[700];

export const container: CSSObject = {
  marginBottom: "24px",
  paddingTop: "24px",
  width: "100%",
  display: "flex",
  gap: "16px",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  textAlign: "center",
  padding: "0.75em 1em 2.5em 1em",
  [mq.downTo(sm)]: {
    padding: "0.75em 2.5em 2.5em 2.55em",
  },

  [mq.downTo(md)]: {
    padding: "0.75em 5em 2.5em 5em",
  },
};

export const headerWrapper: CSSObject = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "center",
  justifyContent: "flex-start",

  [mq.downTo(xs)]: {
    flexDirection: "row",
  },
};

export const heading: CSSObject = {
  fontSize: "20px",
  margin: "0",
  lineHeight: "120%",
  fontFamily: "Noto Serif",
  color: greyDark,
  [mq.downTo(xs)]: {
    fontSize: "24px",
    lineHeight: "133%",
  },
};

export const contentWrapper: CSSObject = {
  width: "100%",
  display: "flex",
  gap: "16px",
  alignItems: "center",
  justifyContent: "flex-start",
  color: greyDark,
  background: "#FFF1C6",
  borderRadius: "16px",
  position: "relative",
  [mq.downTo(md)]: {
    justifyContent: "space-between",
  },
};

export const textWrapper: CSSObject = {
  width: "100%",
  display: "flex",
  minWidth: "288px",
  maxWidth: "536px",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  fontFamily: "Circular",
  textAlign: "initial",
  padding: "16px",
  zIndex: 2,

  h1: {
    fontSize: "24px",
    fontWeight: "700",
    lineHeight: "133%",
    margin: "0px",
    marginBottom: "16px",
  },
  p: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "150%",
    margin: "0px",
    marginBottom: "24px",
  },

  [mq.downTo(xs)]: {
    padding: "24px",
    minWidth: "441px",
    maxWidth: "542px",
  },

  [mq.downTo(sm)]: {
    minWidth: "530px",
    maxWidth: "768px",
  },
};

export const imageWrapper: CSSObject = {
  maxWidth: "454px",
  overflow: "hidden",
  display: "flex",
  position: "absolute",
  justifyContent: "flex-start",
  top: "0px",
  right: "0px",
  [mq.downTo(xs)]: {
    height: "150px",
  },
  [mq.downTo(sm)]: {
    // width: '50%',
    height: "240px",
    position: "initial",
  },
};

export const imageCss: CSSObject = {
  width: "150px",
  content: 'url("/images/icons/challenge_teacher_homepage_image_small.svg")',
  [mq.downTo(xs)]: {
    content: 'url("/images/icons/challenge_teacher_homepage_image_medium.svg")',
  },
  [mq.downTo(sm)]: {
    width: "454px",
    content: 'url("/images/icons/challenge_teacher_homepage_image_large.svg")',
  },
};
